import { isString } from 'lodash';
import { parse } from 'qs';

import { useRootInstance } from '@issue-detail/utils/useRootInstance';
import { useRoute } from '@issue-detail/utils/useRoute';
import { computed, ref } from '@vue/composition-api';

export const useUrlIssueIdCheck = () => {
  const query = parse(location.search.substring(1));
  const toIntOrNull = (value: unknown) => {
    if (!isString(value)) {
      return null;
    }
    return isNaN(parseInt(value, 10)) ? null : parseInt(value, 10);
  };
  const source = query.source as string | undefined;

  return {
    source,
    projectId: toIntOrNull(query.pid),
    issueId: toIntOrNull(query.issueid || query.issueId),
    commentId: toIntOrNull(query.commentid || query.commentId),
    reminderId: toIntOrNull(query.reminderid || query.reminderId),
    subtaskId: toIntOrNull(query.subtaskid || query.subtaskId)
  };
};

const urlMap: any = {
  'kanban': '看板',
  'team': '团队',
  'roadmap': '路线图',
  'work/list': '工作列表',
  'work/table': '多维表格',
  'release': '版本',
  'dashboard': '工作台',
  'backlog': '规划迭代',
  'epic': '史诗列表'
};
//获取系统内部的地址
export const getSystemUrlSource = () => {
  const pathname = location.pathname;
  const source = Object.keys(urlMap).find(key => pathname.includes(key));
  return source ? urlMap[source] : undefined;
};
